<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="FM-Epigraph-verse-fmepiv-first"><span class="ePub-I"><span epub:type="pagebreak" id="pg_7" title="7">THE LAKEMAN’S LAMENT</span></span></p>
<p class="FM-Epigraph-verse-fmepiv">On the fireach deamhain sit</p>
<p class="FM-Epigraph-verse-fmepiv">Curses muttered, fire spits;</p>
<p class="FM-Epigraph-verse-fmepiv">Hunting people, their delight</p>
<p class="FM-Epigraph-verse-fmepiv">Spilling blood and making fright.</p>
<p class="FM-Epigraph-verse-fmepiv">Better fear than praise of men</p>
<p class="FM-Epigraph-verse-fmepiv">The deamhain strike with spear not pen;</p>
<p class="FM-Epigraph-verse-fmepiv">For the bounty they will take</p>
<p class="FM-Epigraph-verse-fmepiv">Food and furs and bones to break.</p>
<p class="FM-Epigraph-verse-fmepiv">Deamhan footfalls leave no mark</p>
<p class="FM-Epigraph-verse-fmepiv">Coming silent, can’no hark;</p>
<p class="FM-Epigraph-verse-fmepiv">Come in fury and in shade</p>
<p class="FM-Epigraph-verse-fmepiv">Come with magic in the blade.</p>
<p class="FM-Epigraph-verse-fmepiv">Glit’ring spear alit with fire</p>
<p class="FM-Epigraph-verse-fmepiv">Lightning speaks with deamhan ire;</p>
<p class="FM-Epigraph-verse-fmepiv">Throwing stones without a sling</p>
<p class="FM-Epigraph-verse-fmepiv">Fly away without a wing!</p>
<p class="FM-Epigraph-verse-fmepiv">Oftentimes a lakeman strays</p>
<p class="FM-Epigraph-verse-fmepiv">Into fireach deamhan’s way;</p>
<p class="FM-Epigraph-verse-fmepiv">Oftentimes the deamhan’s smile</p>
<p class="FM-Epigraph-verse-fmepiv">Bleeds the kill for all the while.</p>
<p class="FM-Epigraph-verse-fmepiv">Usgar deamhan, why such joy</p>
<p class="FM-Epigraph-verse-fmepiv">To break the smile of a boy;</p>
<p class="FM-Epigraph-verse-fmepiv">Usgar deamhan, why delight</p>
<p class="FM-Epigraph-verse-fmepiv">In spilling blood and making fright?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?36281e3d